// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-card--reveal[data-v-304e2b30] {\n  bottom: 0;\n  opacity: 1 !important;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.v-card__text[data-v-304e2b30] {\n  height: calc(100% - 52px);\n}\n.v-card__actions[data-v-304e2b30] {\n  min-height: 52px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
